<div *ngIf="loading" id="preloader" class="bg-transparent d-flex justify-content-center align-items-center">
  <div class="spinner-chase">
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
  </div>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-0 shadow-none">
        <div class="card-body">
          <form [formGroup]="storeListForm" (ngSubmit)="onSubmit()" class="mb-3">
            <div class="row g-3">
              <div class="col-lg-8 col-xl-6">
                <div class="input-group" [ngClass]="{
                    'is-invalid': submitted && f.search_value.errors
                  }">
                  <select class="form-select input-rounded input-focus-border" style="max-width: 120px"
                    formControlName="search_type">
                    <option value="name" selected>
                      {{ "GENERALS.NAME" | translate }}
                    </option>
                    <option value="schema">ID</option>
                  </select>
                  <input type="text" class="form-control input-rounded input-focus-border rounded-form" [placeholder]="
                      user_search_placeholder_map[
                        storeListForm.get('search_type').value
                      ] | translate
                    " [ngClass]="{
                      'is-invalid': submitted && f.search_value.errors
                    }" formControlName="search_value" />
                </div>
                <div *ngIf="submitted && f.search_value.errors" class="invalid-feedback">
                  <div *ngIf="f.search_value.errors.pattern">
                    {{ "GENERALS.PLEASEENTERVALIDID" | translate }}
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-xl-2">
                <input class="form-control input-rounded input-focus-border rounded-form"
                  [placeholder]="'GENERALS.SELECTDATE' | translate" name="dp" bsDatepicker
                  [bsConfig]="{ showWeekNumbers: false }" autocomplete="off" formControlName="created_date" />
              </div>
              <div class="col-lg-4 offset-lg-8 col-xl-2 offset-xl-2">
                <md-filled-button class="w-100" type="submit">
                  <i class="bx bx-search-alt align-middle"></i>
                  {{ "GENERALS.SEARCH" | translate }}
                </md-filled-button>
              </div>
            </div>
          </form>
          <!-- Nav tabs -->

          <div class="row justify-content-center" *ngIf="page && page.length > 0">
            <div class="col-xl-12">
              <div [ngStyle]="{ height: mode === 'selector' ? '55vh' : 'auto' }">
                <ngx-simplebar data-simplebar="init" class="simplebar-scrollable-x h-100">
                  <div class="table-responsive">
                    <table class="table table-striped align-middle table-nowrap table-hover">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" class="ps-3 rounded-top-4 rounded-end-0">
                            {{ "GENERALS.NAME" | translate }}
                          </th>
                          <th scope="col">
                            {{ "GENERALS.DESCRIPTION" | translate }}
                          </th>
                          <!-- <th scope="col" class="ps-3 rounded-top-4 rounded-end-0">{{ "GENERALS.DESCRIPTION" | translate }}</th> -->
                          <th scope="col">
                            {{ "GENERALS.CREATEDDATE" | translate }}
                          </th>
                          <th scope="col" class="text-center rounded-top-4 rounded-start-0">
                            {{ "GENERALS.ACTION" | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of page">
                          <td>
                            <p class="mb-0 fw-bold">{{ data.name }}</p>
                          </td>
                          <td>
                            <p class="mb-0 fw-normal">{{ data.description }}</p>
                          </td>
                          <td>
                            <p class="mb-0 font-size-14 fw-bold">
                              {{ data.created_date }}
                            </p>
                          </td>

                          <td class="text-center">
                            <div class="form-check d-flex align-items-center justify-content-center">
                              <input type="checkbox" id="formCheck1" class="form-check-input"
                                (change)="selectUsers(data)" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ngx-simplebar>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="page.length === 0">
            <div class="col text-center mt-4 mb-0">
              <h6>
                {{ search_message }}
              </h6>
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <ul class="ps-0 mt-4">
                <button class="btn btn-outline-secondary d-flex align-items-center pt-0 pb-0 ps-1 p-2"
                  id="pagination_back" (click)="backPage()">
                  <i class="mdi mdi-chevron-left font-size-18"></i>
                  <p class="mb-0">{{ "GENERALS.PREV" | translate }}</p>
                </button>
              </ul>
            </div>
            <div class="col-2 d-flex justify-content-center align-items-center">
              <p class="avatar-xs invisible mb-0" id="showPageNumber">
                <span class="avatar-title rounded-circle bg-primary">
                  {{ currentPage }}
                </span>
              </p>
            </div>
            <div class="col-5">
              <ul class="d-flex justify-content-end ps-0 mt-4">
                <button class="btn btn-outline-secondary d-flex align-items-center pt-0 pb-0 ps-2 pe-1"
                  id="pagination_next" (click)="nextPage()">
                  <p class="mb-0">{{ "GENERALS.NEXT" | translate }}</p>
                  <i class="mdi mdi-chevron-right font-size-18"></i>
                </button>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-danger w-md rounded-pill me-2" (click)="cancelEvent()">Cancel</button>
  <button class="btn btn-success w-md rounded-pill" [disabled]="isObjEmpty()" (click)="insertEvent()">
    Done
  </button>
</div>
